var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { PureComponent } from 'react';
import { default as AntTreeSelect } from 'antd/lib/tree-select';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import { basicPropTypes, controlPropTypes } from '../component-props';
import { services } from '@comall-backend-builder/core';
export var TREE_STRATEGY = {
  child: AntTreeSelect.SHOW_CHILD,
  parent: AntTreeSelect.SHOW_PARENT,
  all: AntTreeSelect.SHOW_ALL
};

var TreeSelect = function (_super) {
  __extends(TreeSelect, _super);

  function TreeSelect() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * antd默认只支持展示和提交时的策略相同，因此，为了处理部分特殊需要不同展示的情况，得做特殊处理
     * @param value
     * @param label
     * @param detail
     */


    _this.handleChange = function (value) {
      var _a = _this.props,
          name = _a.name,
          treeCheckable = _a.treeCheckable,
          onChange = _a.onChange; //如果不是选择框形式的多选

      if (!treeCheckable) {
        var newValue = _this.transformValueToChange(value);

        onChange(newValue ? newValue : null, name);
        return;
      }

      var finalValue = value.map(function (_a) {
        var value = _a.value,
            label = _a.label;
        return {
          id: value,
          name: label
        };
      });
      onChange(finalValue, name);
    };
    /**
     * 将treeData的id,name的对象数组转换为需要的value,label对象数组
     * @param options
     * @return {Array}
     */


    _this.transformOptions = function (options) {
      return map(options, function (option) {
        var temp = __assign(__assign({}, option), {
          children: option.children ? _this.transformOptions(option.children) : undefined,
          key: option.id,
          value: option.id,
          title: option.name
        });

        return temp;
      });
    };
    /**
     * 将value的id,name的对象数组转换为需要的形式
     * @return {Array|Object|String|Undefined}
     * @param value
     */


    _this.transformValue = function (value) {
      if (!value) {
        return undefined;
      }

      var multiple = _this.props.multiple;

      if (!multiple) {
        var newVal = value;
        return __assign(__assign({}, newVal), {
          value: newVal.id,
          title: newVal.name
        });
      }

      return map(value, function (value) {
        return __assign(__assign({}, value), {
          value: value.id,
          title: value.name
        });
      });
    };
    /**
     * 将value的 value,label的对象数组转换为需要的格式
     * @return {Array|Object|Undefined}
     * @param value
     */


    _this.transformValueToChange = function (value) {
      if (!value) {
        return undefined;
      }

      var multiple = _this.props.multiple;

      if (!multiple) {
        var newVal = value;
        return __assign(__assign({}, newVal), {
          id: newVal.value,
          name: newVal.label
        });
      }

      return map(value, function (value) {
        return __assign(__assign({}, value), {
          id: value.value,
          name: value.label
        });
      });
    };

    return _this;
  }

  TreeSelect.prototype.render = function () {
    //其他部分属性同antd组件属性
    var _a = this.props,
        loadData = _a.loadData,
        showStrategy = _a.showStrategy,
        treeCheckable = _a.treeCheckable,
        _b = _a.placeholder,
        placeholder = _b === void 0 ? services.language.getText('common.pleaseSelect') : _b,
        multiple = _a.multiple,
        options = _a.options,
        value = _a.value,
        otherProps = __rest(_a, ["loadData", "showStrategy", "treeCheckable", "placeholder", "multiple", "options", "value"]);

    if (treeCheckable) {
      multiple = true;
    }

    var treeSelectProps = __assign(__assign({}, otherProps), {
      multiple: multiple,
      loadData: loadData,
      placeholder: placeholder,
      treeCheckable: treeCheckable,
      labelInValue: true,
      onChange: this.handleChange,
      showCheckedStrategy: TREE_STRATEGY[showStrategy] || TREE_STRATEGY.child,
      value: this.transformValue(value),
      treeData: this.transformOptions(options)
    });

    return React.createElement(AntTreeSelect, __assign({}, treeSelectProps));
  };

  TreeSelect.defaultProps = {
    showStrategy: 'child'
  };
  TreeSelect.propTypes = __assign(__assign(__assign({}, basicPropTypes), controlPropTypes), {
    submitStrategy: PropTypes.oneOf(['child', 'parent', 'all']),
    showStrategy: PropTypes.oneOf(['child', 'parent', 'all']),
    multiple: PropTypes.bool,
    treeCheckable: PropTypes.bool,
    loadData: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
  });
  return TreeSelect;
}(PureComponent);

export { TreeSelect };